
export const loaderActive = (action, dispatch) => {
      dispatch({
        type: 'LOADER_ACTIVE',                
        value: action                
    });     
};